"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AutocompleteInput = void 0;
const Autocomplete_1 = __importDefault(require("@material-ui/lab/Autocomplete"));
const React = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const label_1 = __importDefault(require("../label"));
const input_styles_1 = require("./input-styles");
const StyledInput = styled_components_1.default.input `
  ${input_styles_1.inputStyles}
  ${input_styles_1.inputFieldStyles}
  &:focus-visible {
    outline: ${(props) => props.theme.outline};
    outline-offset: 1px;
    box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.23);
  }
  width: 100%;
`;
/**
 * AutocompleteInput can only be used controlled.
 * Example:
 * const options: AutocompleteOptionType[] = [...]
 *  <AutocompleteInput
 *       options={options}
 *       value={value}
 *       onChange={onChange}
 *       onSelectionChange={onSelectionChange}
 *     />
 */
const AutocompleteInput = (_a) => {
    var { onChange, options = [], ariaLabel = undefined, onSelectionChange, label = undefined, error, noOptionsText = undefined, getOptionDisabled, disabled = false, name, value } = _a, props = __rest(_a, ["onChange", "options", "ariaLabel", "onSelectionChange", "label", "error", "noOptionsText", "getOptionDisabled", "disabled", "name", "value"]);
    const handleChange = (e, updatedValue) => {
        if (onChange) {
            onChange(updatedValue, e);
        }
    };
    const handleSelectionChange = (event, selectedValue) => {
        const empty = {
            label: '',
            value: '',
        };
        if (onSelectionChange) {
            onSelectionChange(selectedValue || empty);
        }
    };
    return (React.createElement(Autocomplete_1.default, Object.assign({ "aria-label": ariaLabel, options: options, getOptionLabel: (option) => option.label, onChange: handleSelectionChange, noOptionsText: noOptionsText, onInputChange: handleChange, freeSolo: !noOptionsText, disabled: disabled, getOptionDisabled: getOptionDisabled, getOptionSelected: (option, selected) => option.value === selected.value, renderInput: (params) => (React.createElement("div", { ref: params.InputProps.ref },
            label && React.createElement(label_1.default, { error: error }, label),
            React.createElement(StyledInput, Object.assign({ type: "text", "aria-label": ariaLabel, error: error, name: name, value: value }, params.inputProps)))) }, props)));
};
exports.AutocompleteInput = AutocompleteInput;
exports.default = exports.AutocompleteInput;
